export default '5.25.3';
